import axios from "axios";
import {
  IAddNewOrUpdateAgent,
  IAgentAuthListItem,
  IAuthListResponse,
  IEmployeeManagementRequest,
  IEmployeeManagementResponse,
  IRemoveSimBlockRequest,
  IRemoveSimBlockResponse,
} from "models/Employee/employeeManagement.model";
import { ITokenModel } from "models/Login/token.model";

export const GetEmployee = async (
  empParams: ITokenModel
): Promise<IEmployeeManagementResponse> => {
  const reqData = serviceEmpModelCreator(empParams);
  try {
    const { data } = await axios.post<IEmployeeManagementResponse>(
      "/api/entrypoint",
      reqData,
      {
        headers: {
          Authorization: `Bearer ${empParams.access_token}`,
        },
      }
    );

    if (
      data.DialogBoxes.length > 0 ||
      (data.ReturnCode !== null && data.ReturnCode != 0)
    ) {
      let mssgg =
        data.DialogBoxes.length > 0
          ? data.DialogBoxes[0].Message
          : "Şu anda size hizmet veremiyoruz. Lütfen daha sonra tekrar deneyiniz.";
      return mssgg;
    }

    return data;
  } catch (error) {
    console.log(`EMPLOYEEMANAGEMENT__GETEMPLOYEE_SERVICE_ERROR => `, error);
    throw error;
  }
};
const serviceEmpModelCreator = (
  empParams: ITokenModel
): IEmployeeManagementRequest => {
  let req = {
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: empParams.TokenSessionId,
    igsEnc: null,
    NextTransactionUrl: "MPSAgent/ManagePosAndAgent",
  };

  return req;
};

export const SetEmployeeOperations = async (
  empParams: ITokenModel,
  MobileNo: string,
  Status: string
): Promise<IEmployeeManagementResponse> => {
  const reqData = serviceEmpOperationModelCreator(empParams, MobileNo, Status);
  try {
    const { data } = await axios.post<IEmployeeManagementResponse>(
      "/api/entrypoint",
      reqData,
      {
        headers: {
          Authorization: `Bearer ${empParams.access_token}`,
        },
      }
    );

    if (
      data.DialogBoxes.length > 0 ||
      (data.ReturnCode !== null && data.ReturnCode != 0)
    ) {
      let mssgg =
        data.DialogBoxes.length > 0
          ? data.DialogBoxes[0].Message
          : "Şu anda size hizmet veremiyoruz. Lütfen daha sonra tekrar deneyiniz.";
      return mssgg;
    }

    return data;
  } catch (error: any) {
    console.log(
      `EMPLOYEEMANAGEMENT__SETEMPLOYEEOPERATIONS_SERVICE_ERROR => `,
      error
    );
    return error;
  }
};
const serviceEmpOperationModelCreator = (
  empParams: ITokenModel,
  MobileNo: string,
  Status: string
): IEmployeeManagementRequest => {
  let req = {
    Agent: { MobileNo, Status },
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: empParams.TokenSessionId,
    igsEnc: null,
    NextTransactionUrl: "MPSAgent/UpdateAgentStatus",
  };

  return req;
};

export const GetAuthList = async (
  empParams: ITokenModel
): Promise<IAuthListResponse> => {
  const reqData = serviceAuthListModelCreator(empParams);
  try {
    const { data } = await axios.post<IAuthListResponse>(
      "/api/entrypoint",
      reqData,
      {
        headers: {
          Authorization: `Bearer ${empParams.access_token}`,
        },
      }
    );
    if (data.DialogBoxes.length > 0) throw data.DialogBoxes[0].Message;
    return data;
  } catch (error) {
    console.log(`EMPLOYEEMANAGEMENT__GETAUTHLIST_SERVICE_ERROR => `, error);
    throw error;
  }
};
const serviceAuthListModelCreator = (
  empParams: ITokenModel
): IEmployeeManagementRequest => {
  let req = {
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: empParams.TokenSessionId,
    igsEnc: null,
    NextTransactionUrl: "MPSAgent/AuthList",
  };

  return req;
};

export const AddNewOrUpdateAgentAsync = async (
  empParams: ITokenModel,
  authList: IAgentAuthListItem[],
  mobilNo: string,
  name: string,
  isEdit: boolean
): Promise<IAddNewOrUpdateAgent> => {
  const reqData = serviceNewAgentModelCreator(
    empParams,
    authList,
    mobilNo,
    name,
    isEdit
  );
  try {
    const { data } = await axios.post<IAddNewOrUpdateAgent>(
      "/api/entrypoint",
      reqData,
      {
        headers: {
          Authorization: `Bearer ${empParams.access_token}`,
        },
      }
    );

    if (
      data.DialogBoxes.length > 0 ||
      (data.ReturnCode !== null && data.ReturnCode != 0)
    ) {
      let mssgg =
        data.DialogBoxes.length > 0
          ? data.DialogBoxes[0].Message
          : "Şu anda size hizmet veremiyoruz. Lütfen daha sonra tekrar deneyiniz.";
      return mssgg;
    }

    return data;
  } catch (error: any) {
    console.log(
      `EMPLOYEEMANAGEMENT__ADDNEWORUPDATEAGENT_SERVICE_ERROR => `,
      error
    );
    return error;
  }
};
const serviceNewAgentModelCreator = (
  empParams: ITokenModel,
  authList: IAgentAuthListItem[],
  mobilNo: string,
  name: string,
  isEdit: boolean
): IEmployeeManagementRequest => {
  let req = {
    Agent: {
      AuthList: authList,
      Id: null,
      MobileNo: mobilNo,
      Name: name,
      Nickname: name,
      ProfileImage: null,
      UserLevel: null,
      Status: null,
      Surname: null,
      UserStatus: null,
    },
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: empParams.TokenSessionId,
    igsEnc: null,
    NextTransactionUrl: isEdit
      ? "MPSAgent/UpdateAgent"
      : "MPSAgent/CreateAgent",
  };

  return req;
};

//sim bloke
export const RemoveSimBlockAsync = async (
  empParams: ITokenModel,
  mobilNo: string
): Promise<IRemoveSimBlockResponse> => {
  const reqData = serviceSimBlockModelCreator(empParams, mobilNo);
  try {
    const { data } = await axios.post<IRemoveSimBlockResponse>(
      "/api/entrypoint",
      reqData,
      {
        headers: {
          Authorization: `Bearer ${empParams.access_token}`,
        },
      }
    );

    if (
      data.DialogBoxes.length > 0 ||
      (data.ReturnCode !== null && data.ReturnCode != 0)
    ) {
      let mssgg =
        data.DialogBoxes.length > 0
          ? data.DialogBoxes[0].Message
          : "Şu anda size hizmet veremiyoruz. Lütfen daha sonra tekrar deneyiniz.";
      return mssgg;
    }

    return data;
  } catch (error: any) {
    console.log(`EMPLOYEEMANAGEMENT__SIMBLOCK_SERVICE_ERROR => `, error);
    return error;
  }
};
const serviceSimBlockModelCreator = (
  empParams: ITokenModel,
  mobilNo: string
): IRemoveSimBlockRequest => {
  let req = {
    AgentMobileNo: mobilNo,
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: empParams.TokenSessionId,
    igsEnc: null,
    NextTransactionUrl: "MPSSimBlock/Open",
  };

  return req;
};
